export const ROWSPAN_CONFIG = {
	groupKey: (row) => `${row.id}_${row.application_number}_${row.crop_id}_${row.crop_detail_id}`,
	subgroupKey: (row) => row.sub_group,
	showSubgroupBorder: true,
	rowspanColumns: [
		"application_order_type_name",
		"crop_text",
		"crop_detail_text",
		"period_text",
		"application_number",
		"phenological_state_text",
		"wetness",
		"status_text",
		"progress_text",
		"actions",
		"_expand",
	],
};

export const base_filter = [
	{ key: "program", label: "Programa", type: "select", value: "", visible: true, placeholder: "Programa Fitosanitario", options: [] },
	{ key: "specie_selector", label: "Especie", type: "select", value: "", visible: true, placeholder: "Seleccione especie...", options: [] },
	{ key: "variety", label: "Variedad", type: "select", value: "", visible: true, placeholder: "Variedad", options: [] },
	{
		key: "phenological_state",
		label: "Estado Fenológico",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Estado Fenológico",
		options: [],
	},
	{ key: "objective", label: "Objetivo", type: "select", value: "", visible: true, placeholder: "Objetivo", options: [] },
	{ key: "dealer_id", label: "Distribuidor", type: "select", value: "", visible: true, placeholder: "Distribuidor", options: [] },
	{ key: "type", label: "Tipo de Programa", type: "select", value: "", visible: true, placeholder: "Tipo de Programa", options: [] },
	{ key: "application_number", label: "N° Aplicación", type: "number", value: "", visible: true, placeholder: "N° Aplicación" },
];

export const base_table = { page: 1, per_page: 100, order_by: "name", order_dir: "asc" };
